import { render, staticRenderFns } from "./PropertySelect.vue?vue&type=template&id=44052704&scoped=true"
import script from "./PropertySelect.vue?vue&type=script&lang=js"
export * from "./PropertySelect.vue?vue&type=script&lang=js"
import style0 from "./PropertySelect.vue?vue&type=style&index=0&id=44052704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44052704",
  null
  
)

export default component.exports